'use strict';

module.exports = function ReactNativeFile(_ref) {
  var uri = _ref.uri,
    name = _ref.name,
    type = _ref.type;
  this.uri = uri;
  this.name = name;
  this.type = type;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-files/public/ReactNativeFile.js
// module id = 1611
// module chunks = 11